import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import ListIcon, { ListIconProps } from 'components/ListIcon';

const OfferListIcon: FC<ListIconProps> = (props) => (
  // the Box is needed to better align the icon with the text
  <Box>
    <ListIcon {...props} />
  </Box>
);

export default OfferListIcon;
